import { createResourceSlice } from '../store/resource/createResourceSlice';
import { EMAIL_DRAFT_RESOURCE } from '../api/resources';

const emailDraftsSlice = createResourceSlice({
    resource: EMAIL_DRAFT_RESOURCE,
    byKey: ['customerId', 'ownerEmployeeId' ],
});
export const {
    indexFulfilled,
    showFulfilled,
    storeFulfilled,
    updateFulfilled,
    destroyFulfilled,
    indexEmailDrafts,
    showEmailDraft,
    storeEmailDraft,
    updateEmailDraft,
    archiveEmailDraft,
    restoreEmailDraft,
    destroyEmailDraft,
} = emailDraftsSlice.actions;
export const {
    selectEmaiDraftlById,
    makeEmailDraftsByIdsSelector,
    selectAllEmailDraftIds,
    selectAllEmailDrafts,
    selectEmailDraftsLoading,
    selectEmailDraftsInitialized,
    selectEmailDraftLoading,
    selectEmailDraftInitialized,
    selectEmailDraftIdsByCustomerId,
    selectEmailDraftIdsByOwnerEmployeeId,
    makeEmailDraftsBySelector,
    selectEmailDraftLoadingByCustomerId,
    selectEmailDraftInitializedByCustomerId,
    selectEmailDraftLoadingByOwnerEmployeeId,
    selectEmailDraftInitializedByOwnerEmployeeId,
} = emailDraftsSlice.selectors;

export const { useEmailDrafts, useEmailDraft, useEmailDraftsByCustomerId, useEmailDraftsByOwnerEmployeeId } =
    emailDraftsSlice.hooks;

export default emailDraftsSlice.reducer;
